import { takeLeading, put } from 'redux-saga/effects';
import { AUTH_SESSION_END } from '@ackee/petrus';
import { logoutFailure } from '@ackee/petrus/es/modules/auth-session/actions/logout';
import { Auth } from 'aws-amplify';
import { history } from 'modules/core/modules/router/config';

import * as Log from 'config/loglevel';
import { SALESFORCE_ACCESS_TOKEN_STORAGE_KEY } from '../../constantsSalesforce';
import config from 'config';

function clearAuthTokens() {
    try {
        localStorage.removeItem(SALESFORCE_ACCESS_TOKEN_STORAGE_KEY);
        for (const key of Object.keys(localStorage)) {
            if (key.startsWith('CognitoIdentityServiceProvider')) {
                localStorage.removeItem(key);
            }
        }
    } catch {
        // ignore
    }
}

function* handleLogout() {
    clearAuthTokens();

    try {
        yield Auth.signOut();
    } catch (error) {
        yield put(logoutFailure(error));
        Log.error(error);
    }

    const loginLocation = window.location.pathname === config.routes.login
        ? { pathname: config.routes.login, search: window.location.search }
        : config.routes.login;
    history.push(loginLocation);
}

export default function* logout() {
    yield takeLeading(AUTH_SESSION_END, handleLogout);
}
